exports.server = "https://multi-vendor-e-commerce-mern-app.vercel.app/api/v1";
